import React, { useState, useEffect } from 'react';
import './CookieBanner.css';

export default function CookieBanner({ onAccept, onDecline }) {
  const [visible, setVisible] = useState(false);
  const [showDetails, setShowDetails] = useState(false);

  useEffect(() => {
    setTimeout(() => setVisible(true), 800);
  }, []);

  const accept = () => { setVisible(false); setTimeout(onAccept, 300); };
  const decline = () => { setVisible(false); setTimeout(onDecline, 300); };

  return (
    <div className={`cookie-banner ${visible ? 'visible' : ''}`}>
      <div className="cookie-inner">
        <div className="cookie-icon">🍪</div>
        <div className="cookie-content">
          <h3 className="cookie-title">Wir verwenden Cookies</h3>
          <p className="cookie-text">
            Wir nutzen Cookies und ähnliche Technologien, um dein Testerlebnis zu verbessern,
            anonyme Nutzungsstatistiken zu erheben und dir relevante Inhalte anzuzeigen.
            {!showDetails && (
              <button className="cookie-link" onClick={() => setShowDetails(true)}>
                Mehr erfahren
              </button>
            )}
          </p>

          {showDetails && (
            <div className="cookie-details">
              <div className="cookie-type">
                <div className="cookie-type-header">
                  <span className="cookie-type-dot essential" />
                  <strong>Notwendige Cookies</strong>
                  <span className="cookie-required">Immer aktiv</span>
                </div>
                <p>Session-Verwaltung, Sicherheit, grundlegende Funktionen des Tests.</p>
              </div>
              <div className="cookie-type">
                <div className="cookie-type-header">
                  <span className="cookie-type-dot analytics" />
                  <strong>Analyse-Cookies</strong>
                  <span className="cookie-optional">Optional</span>
                </div>
                <p>Anonyme Nutzungsstatistiken (Seitenaufrufe, Testabschlüsse). Keine personenbezogenen Daten.</p>
              </div>
              <div className="cookie-type">
                <div className="cookie-type-header">
                  <span className="cookie-type-dot marketing" />
                  <strong>Marketing-Cookies</strong>
                  <span className="cookie-optional">Optional</span>
                </div>
                <p>Kampagnenverfolgung (utm-Parameter) zur Verbesserung unserer E-Mail-Kampagnen.</p>
              </div>
              <a href="/datenschutz" className="cookie-privacy-link">Vollständige Datenschutzerklärung →</a>
            </div>
          )}
        </div>

        <div className="cookie-actions">
          <button className="btn-cookie-accept" onClick={accept}>
            ✓ Alle akzeptieren
          </button>
          <button className="btn-cookie-decline" onClick={decline}>
            Nur notwendige
          </button>
        </div>
      </div>
    </div>
  );
}
